// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Checnovskaya <anastasia.chesnovskaya@celadon.ae>
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { withStyles } from '@material-ui/core';

import { statuses } from '../../../../../../../../config/types';
import { PostcodeWithMap } from '../../../../../../../../components';
import styles from './styles';


const statusApplied = [7, 13, 15];
class NearestPostcodeMobile extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    order: PropTypes.object,
  };

  static defaultProps = {
    classes: {},
    order: {},
  };

  renderTop = () => {
    const { classes, order } = this.props;
    let statusId = 0;
    Object.keys(statuses).map((key) => {
      if (statuses[key] === order.OrderStatus) {
        statusId = key;
      }
      return null;
    });
    statusId = parseInt(statusId, 10);
    const background = statusApplied.includes(statusId) ? classes.paid : classes.processing;

    return (
      <div className={classNames(classes.topContainer, background)}>
        <span className={classes.orderIdText}>{`ORDER ID: ${order.OrderID}`}</span>
        <div className={classes.dateTimeContainer}>
          <span>{order.CreatedOn}</span>
        </div>
      </div>
    );
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.mainContainer}>
        {this.renderTop()}
        <div className={classes.contentContainer}>
          <PostcodeWithMap isInOrderLite={true} />
        </div>
      </div>);
  }
}

export default withStyles(styles)(NearestPostcodeMobile);
